import ScheduleDropdownFilter from 'components/dropdownFilters/DropdownFilter';
import template from 'templates/schedules/__NFLSchedule.tpl';

export default function () {
    let parentContainer = $('#js-schedule-block.schedule-nfl'),
        slug = parentContainer.data('slug'),
        filters = null,
        schedules = null,
        contentMount = parentContainer.find('.footballSchedule__gamesContainer'),
        disclaimer = parentContainer.find('.footballSchedule__disclaimer');

    let init = function () {
        if (parentContainer.length > 0) {
            __setContentContainerLoadingState();

            pullScheduleData((data) => {
                let [filterData, selectedInd] = __parseFilters(data);
                filters = new ScheduleDropdownFilter(filterData);
                filters
                    .setMount(parentContainer.find('.js-dropdown'))
                    .setSelectedIndex(selectedInd)
                    .build();

                let selectedOption = filters.getSelectedOption();
                fetchScheduleBySelectedWeek(selectedOption.value, () =>
                    setTimeout(() => __setContentContainerReadyState(), 300)
                );

                $(filters).on('filterSelected', (e, index, value) => {
                    __setContentContainerLoadingState();
                    fetchScheduleBySelectedWeek(value, () =>
                        setTimeout(() => __setContentContainerReadyState(), 300)
                    );
                });
            });
        }
    };

    let fetchScheduleBySelectedWeek = function (value, callback) {
        // exception condition when (value == false) meaning no selected date, most likely the schedule date has passed
        if (!value) {
            __collapseBlock();
        }

        let splitValues = value.split('|');
        let seasonType = splitValues[0],
            weekNum = splitValues[1];

        let foundSchedules = __searchSchedule(seasonType, weekNum);

        if (foundSchedules) {
            __clearContentMount();

            __renderSchedules(foundSchedules);

            callback();
        } else {
            __collapseBlock();
        }
    };

    let __collapseBlock = function () {
        parentContainer.hide();
    };

    let __setContentContainerLoadingState = function () {
        contentMount.removeClass('ready').addClass('loading');
        disclaimer.hide();
    };

    let __setContentContainerReadyState = function () {
        contentMount.removeClass('loading').addClass('ready').css('min-height', 0);
        disclaimer.show();
    };

    let __renderSchedules = function (data) {
        contentMount.append(template({ schedules: __prepDataBeforeRender(data) }));
    };

    let __prepDataBeforeRender = function (data) {
        let seen = [];
        let headers = data
            .map((el) => {
                return {
                    label: el.formattedGameTime,
                    labelMobile: el.formattedGameTimeMobile
                };
            })
            .filter((el) => (seen.indexOf(el.label) >= 0 ? false : seen.push(el.label)));
        let prepData = [];

        for (let k = 0; k < headers.length; k++) {
            prepData.push({
                header: headers[k],
                matches: data.filter((el) => {
                    return el.formattedGameTime === headers[k].label;
                })
            });
        }

        return prepData;
    };

    let __clearContentMount = function () {
        contentMount.html('');
    };

    let __searchSchedule = function (seasonType, weekNum) {
        return schedules.filter(
            (schedule) =>
                schedule.seasonType === seasonType && schedule.weekNum === parseInt(weekNum)
        );
    };

    let __parseFilters = function (data) {
        let filters = [];
        let seen = [];
        let selectedInd = 0;
        let today = new Date();

        for (let i = 0; i < data.length; i++) {
            let temp = data[i].seasonType + '|' + data[i].weekNum;

            if (seen.indexOf(temp) < 0) {
                filters.push({
                    title: data[i].weekName,
                    value: temp
                });

                seen.push(temp);

                let newWeekStartDate = getNflWeekStart(data[i].rawGameTime);

                if (today > newWeekStartDate) {
                    selectedInd++;
                }
            }
        }

        return [filters, selectedInd];
    };

    let pullScheduleData = function (callback) {
        let endpoint = `/shows/${slug}/xhr/football-schedule/`;
        $.ajax({
            url: endpoint,
            dataType: 'json'
        }).done((resp) => {
            if (resp) {
                schedules = resp.result.data;

                callback(resp.result.data);
            }
        });
    };

    // Return the date of the Tuesday following game day (as the NFL week starts on Tuesdays)
    let getNflWeekStart = function (gameDate) {
        var b = gameDate.split(/\D+/);
        var weekStart = new Date(b[0], --b[1], b[2], 0, 0, 0);
        weekStart = weekStart.setDate(weekStart.getDate() + 2);
        return weekStart;
    };

    init();
}
